if (!customElements.get('sb-product-modal')) {
  customElements.define(
    'sb-product-modal',
    class SbProductModal extends HTMLElement {
      constructor() {
        super();
        this.CLOSE_DURATION = 620;
        this.lastTrigger = null;
        this.closeTimer = null;
      }

      connectedCallback() {
        this.tabs = this.querySelectorAll('[data-sb-product-modal-tab]');
        this.panels = this.querySelectorAll('[data-sb-product-modal-panel]');
        this.closeBtn = this.querySelector('[data-sb-product-modal-close]');
        this.backdrop = this.querySelector('[data-sb-product-modal-backdrop]');

        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.close = this.close.bind(this);

        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keydown', this.onKeydown);

        if (this.closeBtn) this.closeBtn.addEventListener('click', this.close);
        if (this.backdrop) this.backdrop.addEventListener('click', this.close);

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            console.log('tab clicked', tab.getAttribute('data-sb-product-modal-tab'));
            this.setActiveTab(tab.getAttribute('data-sb-product-modal-tab'));
          });
        });
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keydown', this.onKeydown);
      }

      onDocumentClick(event) {
        const trigger = event.target.closest('[data-sb-product-modal-open]');
        if (!trigger) return;

        const targetId = trigger.getAttribute('data-sb-product-modal-open');
        if (targetId != null && targetId !== '' && targetId !== this.id) return;

        event.preventDefault();

        let idx = parseInt(trigger.getAttribute('data-sb-product-modal-tab-index'), 10);
        const tabKey = trigger.getAttribute('data-sb-product-modal-tab');
        console.log('trigger', trigger, idx, tabKey);
        const tabPanel = document.querySelector('data-sb-product-modal-tabpanel');
        if (
          tabKey === 'ingredients' && tabPanel && tabPanel === 'ingredients'
        ) {
          idx = parseInt(tabPanel.getAttribute('data-sb-product-modal-tab'), 10);
        }
        if (Number.isNaN(idx)) idx = 0;

        this.open(idx, trigger);
      }

      onKeydown(event) {
        if (event.key === 'Escape' && this.classList.contains('is-open')) this.close();
      }

      setActiveTab(index) {
        const key = String(index);
        this.tabs.forEach((tab) => {
          tab.classList.toggle('is-active', tab.getAttribute('data-sb-product-modal-tab') === key);
        });
        this.panels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.getAttribute('data-sb-product-modal-panel') === key);
        });
      }

      open(index, trigger) {
        this.lastTrigger = trigger || null;
        if (this.closeTimer) {
          clearTimeout(this.closeTimer);
          this.closeTimer = null;
        }
        const panelCount = this.panels.length;
        let activeIndex = index;
        if (activeIndex < 0 || activeIndex >= panelCount) activeIndex = 0;
        this.setActiveTab(activeIndex);
        this.removeAttribute('hidden');
        // Force reflow so the transition runs.
        this.offsetWidth;
        this.classList.add('is-open');
        this.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        document.body.style.scrollBehavior = 'auto';
        requestAnimationFrame(() => {
          if (this.closeBtn) this.closeBtn.focus();
        });
      }

      close() {
        this.classList.remove('is-open');
        this.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        document.body.style.scrollBehavior = '';
        if (this.closeTimer) clearTimeout(this.closeTimer);
        this.closeTimer = setTimeout(() => {
          this.setAttribute('hidden', '');
          this.closeTimer = null;
        }, this.CLOSE_DURATION);
        if (this.lastTrigger && typeof this.lastTrigger.focus === 'function') {
          this.lastTrigger.focus();
        }
        this.lastTrigger = null;
      }
    }
  );
}
